import React, { useEffect, useState } from 'react';

import ApiServices from '~services';

import { ToolOutlined } from '@ant-design/icons';

function MaintenanceCard({ arrIdSelectVendor, setMaintenanceCounter }) {
  const [dataReplacement, setDataReplacement] = useState([]);
  const getInit = async () => {
    try {
      const { data } = await ApiServices.getRPVehicleReplacement(arrIdSelectVendor);
      if (data) {
        setDataReplacement(data);
        const sumTotal = data?.reduce((sumTotal, item) => {
          return parseInt(sumTotal) + parseInt(item?.count);
        }, 0);

        setMaintenanceCounter((prev) => {
          prev.warning = data?.length || 0;
          prev.total = sumTotal || 0;

          return prev;
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    arrIdSelectVendor?.length && getInit();
  }, [arrIdSelectVendor]);

  return (
    <div className='card'>
      <div className='card-header'>
        <ToolOutlined className='card-icon green' />
        <h3 className='card-title'>Bảo Trì Sửa Chữa</h3>
      </div>

      {dataReplacement?.map((item) => {
        const clickable = item.count > 0;

        return (
          <div
            key={item.warningName}
            className={`row ${clickable ? 'clickable' : ''}`}
            onClick={
              clickable
                ? () =>
                    window.open(
                      `/report-vehicle-replacement?categoryId=${item.categoryId}&vendorId=${arrIdSelectVendor}`,
                      '_blank'
                    )
                : undefined
            }
          >
            <span>{item.warningName}</span>
            <b className={item.totalBg}>{item.count}</b>
          </div>
        );
      })}
    </div>
  );
}

export default MaintenanceCard;
